import { useBodyLock } from '@portal/components'
import { QueryClientProvider } from '@tanstack/react-query'
import React from 'react'

import { DQLHTTPResponse } from '../../types'
import { queryClient } from './client'
import { DQLEditorPortalContext } from './context'
import DQLEditorLayout from './DQLEditorLayout'
import DQLEditorProvider from './DQLEditorProvider'

export type DQLEditorProps = {
  /**
   * The access token to use when interacting with the HTTP API. This is not directly
   * used by the DQLEditor, it is used to determine ready state for issuing queries.
   */
  accessToken?: string
  /**
   * A function to refresh the access token.
   */
  refreshToken?: () => Promise<void>
  /**
   * A function that will be called when the user clicks the "Run" button in the QueryEditor.
   * This will call the HTTP API with the provided query and return the results.
   */
  executeQuery: (query: string) => Promise<DQLHTTPResponse>
  /**
   * An optional initial query to execute on initial load
   */
  initialQuery?: string
} & DQLEditorPortalContext
/**
 * The top-level component for the DQLEditor functionality
 */
export default function DQLEditor(props: DQLEditorProps) {
  // Prevent scrolling on the body. This is necessary when rendering the DQLEditor in the Portal,
  // otherwise you can scroll _slightly_ up and down past the bounds of the DQLEditor and it looks weird.
  useBodyLock()

  return (
    <QueryClientProvider client={queryClient}>
      <DQLEditorProvider {...props}>
        <DQLEditorLayout />
      </DQLEditorProvider>
    </QueryClientProvider>
  )
}
